export default {
    API_URL: 'https://api-cts.herokuapp.com'
    //API_URL: 'https://cts-api.herokuapp.com'
  }